import request from '@dashboard/services/request';

const { REACT_APP_API_URL: apiUrl } = process.env;

const signup = data =>
  request(`${apiUrl}/signup`, null, {
    body: JSON.stringify(data),
    method: 'POST',
  });

export { signup };
